import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { FinancialEntityBranch } from '@models/swagger';
import { FinancialEntityBranchParams } from './service';

export enum FinancialEntityBranchActions {
  Failure = '[Application Utilities FinancialEntityBranch] Failure',
  Request = '[Application Utilities FinancialEntityBranch] Request',
  Success = '[Application Utilities FinancialEntityBranch] Success',
}

export const FinancialEntityBranchFailure = createAction(
  FinancialEntityBranchActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const FinancialEntityBranchRequest = createAction(
  FinancialEntityBranchActions.Request,
  props<{ parameters: FinancialEntityBranchParams }>()
);

export const FinancialEntityBranchSuccess = createAction(
  FinancialEntityBranchActions.Success,
  props<{ data: FinancialEntityBranch }>()
);
